import { useEffect, useMemo, useState } from "react";
import AstrologerCard from "../UI/AstrologerCard";
import {
  fetchAstrologers,
  filterAstrologersByTab,
} from "../../api/astrologerApi";
import "../../assets/css/home.css";

export default function GuidedMastersDetail() {
  const [astrologers, setAstrologers] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetchAstrologers()
      .then(({ astrologers: items, tabs: apiTabs }) => {
        if (cancelled) return;
        setAstrologers(items);
        setTabs(apiTabs);
        setActiveCategory((current) =>
          apiTabs.includes(current) ? current : apiTabs[0] || ""
        );
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Failed to load astrologers");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const filtered = useMemo(
    () => filterAstrologersByTab(astrologers, activeCategory),
    [astrologers, activeCategory]
  );

  return (
    <section className="space-top">
      <div className="container">
        <div className="about-title mb-4">
          <h1 className="text-lora font-semibold">Guided by the Masters</h1>
          <p>
            Connect with seasoned experts who translate ancient wisdom into
            practical guidance for your success and harmony.
          </p>
        </div>

        {tabs.length > 0 && (
          <div className="astro-filter-tabs d-flex flex-nowrap gap-2 mb-4">
            {tabs.map((category) => (
              <button
                key={category}
                type="button"
                className={`btn cutom-tab-style astro-filter-tab ${
                  activeCategory === category ? "active-tab-btn-style" : ""
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        )}

        {loading && <p className="text-center py-5">Loading astrologers...</p>}
        {error && <p className="text-center text-danger py-5">{error}</p>}
        {!loading && !error && filtered.length === 0 && (
          <p className="text-center py-5">
            {activeCategory
              ? `No astrologers available for ${activeCategory}.`
              : "No astrologers available."}
          </p>
        )}

        <div className="row g-4">
          {filtered.map((astrologer) => (
            <div
              key={astrologer.id}
              className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex"
            >
              <AstrologerCard
                astrologer={{
                  ...astrologer,
                  specialty: activeCategory || astrologer.specialty,
                }}
                actionLabel="Book a Consultation"
                actionTo="/consult"
                className="w-100"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
